import { Box, Dialog, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import UserAuthLogin from '../../Auth/Login';
import { SecondaryActionButton } from './SecondaryActionButton';
import { useParams } from 'react-router-dom';
import { auth, analytics } from 'firebase';
import { logEvent } from 'firebase/analytics';
import { useAuthState } from 'react-firebase-hooks/auth';

const style = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  textAlign: 'center',
  display: 'block',
  width: '100%',
};

interface Props {
  setVideoPlayed(val: boolean): any;
}

function GetStarted({ setVideoPlayed }: Props) {
  const [isLess, setIsLess] = useState(true);
  const [redirectURI, setRedirectURI] = useState('');

  const useStyles = makeStyles({
    paper: {
      position: 'absolute',
      bottom: '-50px',
      width: '100%',
      paddingBottom: '70px',
      borderRadius: '0px!important',
    },
  });
  const classes = useStyles();
  const { restaurantId } = useParams();
  const [user] = useAuthState(auth);

  useEffect(() => {
    if (restaurantId) {
      setRedirectURI('/explore/'.concat(restaurantId));
    }
  }, [restaurantId]);

  return (
    <Box sx={style}>
      <Grid container>
        <Grid item xs={12} mb={'20px'}>
          <SecondaryActionButton
            title={'Get Started'}
            onClick={() => {
              // Analytics: Track Get Started Click
              if (restaurantId) {
                // Check if user is returning
                const hasVisitedKey = `has_visited_goldi_${restaurantId}`; // Scope directly to restaurant or global? User asked for "users coming in the door". Let's use global for device uniqueness or scoped?
                // "is_returning_user" usually implies simply "have they used the app before".
                // Let's stick to the plan: 'goldi_has_visited' global flag.
                const isReturning = !!localStorage.getItem('has_visited_goldi');

                logEvent(analytics, 'get_started_clicked', {
                  restaurant_id: restaurantId,
                  restaurant_name: 'Unknown', // We don't have name here easily without context, but restaurantId is key.
                  is_returning_user: isReturning
                });

                // Set flag for next time
                localStorage.setItem('has_visited_goldi', 'true');
              }
              setVideoPlayed(true);
            }}
          />
        </Grid>
        <Grid item xs={12} mb={'20px'}>
          <Dialog
            classes={{ paper: classes.paper }}
            open={!isLess}
            onClose={() => setIsLess(true)}
          >
            <UserAuthLogin
              redirectURI={redirectURI}
              onClose={() => setIsLess(true)}
            />
          </Dialog>
          {!user?.isAnonymous && (
            <SecondaryActionButton
              title={'Log In'}
              onClick={() => {
                setIsLess(false);
              }}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default GetStarted;
